// NPM
import { omitBy, isNull, isEmpty } from "lodash"
import { useTranslation } from "react-i18next"
import React, { useState, useEffect } from "react"

// UTILITY
import errorHandler from "Utils/error-handler"

// VALIDATOR
import { ServicePointTypeSchema } from "./service-point-type-form-validation"

// HOOKS
import useQuery from "Hooks/query.hook"

// STYLE
import "../delivery-forms.scss"

// COMPONENTS
import { Col, Row } from "antd"
import {
    AlertBox,
    Button,
    TextInput
} from "@life-line-lab/components-react"

interface ServicePointTypeFormProps {
    onSubmit: (data: any) => void
    onUpdate: (data: any) => void
    onFetch: (pointTypeID: string) => void
    data?: any
}

const ServicePointTypeForm: React.FC<ServicePointTypeFormProps> = ({
    onSubmit,
    onUpdate,
    onFetch,
    data
}) => {
    const query = useQuery()
    const id = query.get("id")
    const { t } = useTranslation()

    const initialInput = {
        name: "",
    }
    const initialError = {}

    const [input, setInput] = useState<any>(initialInput)
    const [error, setError] = useState<any>(initialError)

    useEffect(() => {
        if (id) {
            onFetch(id)
        }
        document.body.classList.add('stack-screen--open')
        return () => document.body.classList.remove('stack-screen--open')
    }, [])

    useEffect(() => {
        if (!isEmpty(data)) {
            setInput({
                ...input,
                _id: data._id,
                name: data.name
        })}
    }, [data])

    const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setError(initialError)
        setInput({ ...input, [e.target.name]: e.target.value })
    }

    const handleSubmit = () => {
        try {
            const valInput = {
                ...input,
            }
            const value = ServicePointTypeSchema.validateSync(omitBy(valInput, isNull), {
                strict: false,
                abortEarly: true,
                stripUnknown: true
            })
            id ? onUpdate(value) :  onSubmit(value) 
        } catch (err) {
            console.log(err)
            const { path, value }: any = errorHandler.validation(err)
            setError({ ...error, [path]: t(`${value}`, { field: t(`label.${path}`) }) })
        }
    }

    return (
        <div className="delivery-form">
            <form>
                <div className="main-header">
                    <span className="center header-title">
                        {t(id 
                            ? "label.editField" 
                            : "label.addField", 
                        {field: t("label.servicePointType")}).toUpperCase()}
                    </span>
                </div>

                <Row gutter={[20, 0]} className="mt-32" justify="center">
                    <Col xs={24} sm={24} md={8} className="mb-0">
                        <TextInput
                            isRequired={true}
                            label={t("label.servicePointType")}
                            placeholder={t("txt.enterHere")}
                            value={input.name}
                            name="name"
                            onChange={handleFieldChange}
                        />
                        <AlertBox text={error.name} />
                    </Col>
                </Row>
                <Row className="mt-50" justify="center">
                    <Col className="mb-50">
                        <Button
                            size="large"
                            type="primary"
                            onClick={handleSubmit}
                            label={id
                                ? t("action.update")
                                : t("action.create")
                            }
                        />
                    </Col>
                </Row>
            </form>
        </div>
    )
}

export default ServicePointTypeForm